/**
 * 赔率计算公式
 * 根据剩余时间动态计算下注赔率
 */

/**
 * 计算基于时间的赔率
 * @param {number} remainingSeconds - 剩余秒数
 * @param {number} totalPeriodSeconds - 周期总秒数
 * @param {number} periodMinutes - 周期分钟数 (用于确定基础赔率)
 * @returns {number} - 计算出的赔率
 */
export function calculateTimeBasedOdds(remainingSeconds, totalPeriodSeconds, periodMinutes) {
  // 时间比例 (0-1)
  const timeRatio = remainingSeconds / totalPeriodSeconds;
  
  // 基础赔率配置
  const oddsConfig = {
    5: { base: 1.02, max: 1.08 },   // 5分钟: 1.02x - 1.08x
    15: { base: 1.05, max: 1.20 },  // 15分钟: 1.05x - 1.20x
    30: { base: 1.10, max: 1.35 }   // 30分钟: 1.10x - 1.35x
  };
  
  const config = oddsConfig[periodMinutes] || oddsConfig[5];
  
  // 计算赔率: 基础赔率 + (时间比例 * 赔率范围)
  const oddsRange = config.max - config.base;
  const calculatedOdds = config.base + (timeRatio * oddsRange);
  
  return calculatedOdds;
}

/**
 * 格式化赔率显示
 * @param {number} odds - 赔率数值
 * @returns {string} - 格式化的赔率字符串 "1.25x"
 */
export function formatOdds(odds) {
  return `${odds.toFixed(2)}x`;
}

/**
 * 根据剩余时间获取赔率颜色类
 * @param {number} remainingSeconds - 剩余秒数
 * @param {number} totalPeriodSeconds - 周期总秒数
 * @returns {string} - CSS类名
 */
export function getOddsColorClass(remainingSeconds, totalPeriodSeconds) {
  const timeRatio = remainingSeconds / totalPeriodSeconds;
  
  if (timeRatio > 0.7) return 'text-green-400';      // 时间充足 - 绿色
  if (timeRatio > 0.3) return 'text-yellow-400';     // 时间中等 - 黄色
  return 'text-red-400';                              // 时间紧急 - 红色
}

/**
 * 根据剩余时间获取倒计时颜色类
 * @param {number} remainingSeconds - 剩余秒数
 * @returns {string} - CSS类名
 */
export function getCountdownColorClass(remainingSeconds) {
  if (remainingSeconds > 120) return 'text-white';        // 2分钟以上 - 白色
  if (remainingSeconds > 60) return 'text-yellow-400';    // 1-2分钟 - 黄色
  if (remainingSeconds > 30) return 'text-orange-400';    // 30秒-1分钟 - 橙色
  return 'text-red-400 animate-pulse';                    // 30秒以内 - 红色闪烁
}

/**
 * 格式化倒计时显示
 * @param {number} remainingSeconds - 剩余秒数
 * @returns {string} - 格式化的倒计时字符串 (如: "2:30", "0:45")
 */
export function formatCountdown(remainingSeconds) {
  if (remainingSeconds <= 0) return '0:00';
  
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
